module.exports = __webpack_public_path__ + "static/floating-action-button-one-do-da2aabac2e2cea1a3517e8346aad07ec.png";